import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomDropdownPractice from '../../components/Inputs/CustomDropdownPractice';
import practiceConstants from './practiceConstants';

export default class SortMobile extends Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    selectedSort: PropTypes.object.isRequired,
    onChangeSort: PropTypes.func.isRequired,
  };

  selectSortType = (sortType) => {
    this.props.onChangeSort(sortType);
  }

  render() {
    const { selectedSort } = this.props;
    return (
      <CustomDropdownPractice
        categories={practiceConstants.sortTypes}
        selectedCategory={selectedSort}
        onChange={this.selectSortType}
        label={'Сортировать по'}
      />
    );
  }
}